import React, { FC, ReactNode } from 'react';
import translate from '@translate';
import MUIDialog from '@mui/material/Dialog';
import MUIDialogTitle from '@mui/material/DialogTitle';
import MUIDialogContent from '@mui/material/DialogContent';
import MUIDialogActions from '@mui/material/DialogActions';
import MUIBox from '@mui/material/Box';
import Tooltip from '../Tooltip';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/system';
import { SxProps, Theme } from '@mui/material/styles';

const CloseButton = styled('div')({
    color: '#959595',
    float: 'right',
    cursor: 'pointer',
    fontSize: '30px',
    paddingLeft: '10px',

    '&:hover': {
        color: '#585858',
    },

    '& svg': {
        height: '30px',
        width: '30px',
    },
});

export interface DialogProps {
    title?: string;
    dontClose?: boolean;
    onClose?: () => void;
    dividers?: boolean;
    loading?: boolean;
    children?: ReactNode;
    actions?: ReactNode;
    titleElement?: ReactNode;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    sx?: SxProps<Theme>;
    fullWidth?: boolean;
}

const Dialog: FC<DialogProps> = (props) => {
    const onClose = () => {
        if (!props.dontClose && props.onClose) {
            props.onClose();
        }
    };
    return (
        <MUIDialog
            open
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth={props.maxWidth}
            sx={props.sx}
            fullWidth={props.fullWidth}
        >
            <MUIDialogTitle id="alert-dialog-title">
                {props.title}
                {!props.dontClose && (
                    <CloseButton>
                        <Tooltip title={translate('dialog.close')}>
                            <HighlightOffIcon onClick={onClose} />
                        </Tooltip>
                    </CloseButton>
                )}
                {props.titleElement}
            </MUIDialogTitle>
            <MUIDialogContent dividers={props.dividers}>
                {props.loading && (
                    <MUIBox>
                        <CircularProgress color="secondary" size={100} />
                    </MUIBox>
                )}
                {props.children}
            </MUIDialogContent>
            {props.actions && <MUIDialogActions>{props.actions}</MUIDialogActions>}
        </MUIDialog>
    );
};

export default Dialog;
